import { render, staticRenderFns } from "./AnnounceRevocation.vue?vue&type=template&id=4242d6d6&scoped=true&"
import script from "./AnnounceRevocation.vue?vue&type=script&lang=js&"
export * from "./AnnounceRevocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242d6d6",
  null
  
)

export default component.exports